import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { CommonFormService } from 'src/app/shared/utils/common-form.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { comisionesModulo } from '../../diccionarios/comisionesModulo';
import { ReporteDeLiquidacionIndividualService } from '../../services/reporte-de-liquidacion-individual.service';
import { CatalogoIndicadoresService } from '../../services/catalogo-indicadores.service';
import { AltaDeVendedoresService } from '../../services/alta-de-vendedores.service';
import { TipoDeVendedorService } from '../../services/tipo-de-vendedor.service';


@Component({
  selector: 'app-reporte-de-liquidacion-individual',
  templateUrl: './reporte-de-liquidacion-individual.component.html',
  styleUrls: ['./reporte-de-liquidacion-individual.component.css']
})
export class ReporteDeLiquidacionIndividualComponent implements OnInit {

  tituloCard: string = 'Procesamiento De Comisiones';
  tituloForm: string = 'Lista De Procesamiento De Comisiones';

  formulario: FormGroup;
  listVendedores = [];

  mostrarFormulario: boolean = false;
  editableForm: boolean = false;

  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  rowSelection: any;
  textoBuscar: string;

  //componentes para apuntar a diccionario
  DAT_BTNS;
  DAT_MSG;
  DAT_BTNCSS;

  textBoton: string;

  //para cargar con el grid
  listaVacia: boolean = true;
  loading: boolean = false;
  modulo: any = {};
  GUARDAR: string = 'guardar';

  listTipoDeReporte: any[] = [
    {
      clave: 'individual',
      valor: 'INDIVIDUAL'
    },
    {
      clave: 'total',
      valor: 'TOTAL'
    },
  ];

  cmbMeses: { clave: number; valor: string; }[];

  constructor(
    private fb: FormBuilder,
    private commonFormService: CommonFormService,
    private _utils: UtilsService,
    private _catalogo: CatalogoIndicadoresService,
    private _altaDeVendedor: AltaDeVendedoresService,
    private _serviciosCRUD: ReporteDeLiquidacionIndividualService,
    private _tipoDeVendedor: TipoDeVendedorService,
  ) { }

  ngOnInit() {
    this.modulo = comisionesModulo;
    this.DAT_BTNS = this.modulo.button.buttonsNombre;
    this.DAT_MSG = this.modulo.mensajes;
    this.DAT_BTNCSS = this.modulo.button.buttonsCss;

    this.formulario = this.fb.group({
      tipoReporte: ['', [Validators.required]],
      tipoVendedor: ['', []],
      vendedorId: ['', []],
      anio: ['', [Validators.required]],
      inicioMes: ['', [Validators.required]],
      finMes: ['', [Validators.required]],
    });

    this.formulario.get('tipoReporte').setValue('individual');

    this.formulario.get('tipoReporte').valueChanges
      .subscribe((resp) => {
        if (resp == 'individual') {
          this.listVendedores = [];
          this.formulario.get('vendedorId').setValidators([Validators.required]);
          this.formulario.get('vendedorId').updateValueAndValidity();
        }
        else {
          this.formulario.get('vendedorId').setValidators([]);
          this.formulario.get('vendedorId').updateValueAndValidity();

          this.listVendedores.unshift({
            nombreVendedor1: 'TODOS',
            idVendedor: '',
          });

        }

        this.getTiposDeVendedores();
      });

    this.formulario.get('tipoVendedor').valueChanges
      .subscribe((resp) => {
        if (resp) {
          this.vendedores(resp)
        }
        this.getFormValidationErrors();
      });

    // this.listVendedores.unshift({
    //   nombreVendedor1: 'TODOS',
    //   idVendedor: '',
    // });

    this.cargarGridcomponent();
    this.getTiposDeVendedores();
    this.cmbMeses = this._catalogo.catalogoMeses();

  }

  /* FUNCIONES */

  cargarGridcomponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.columnDefs = [
      {
        headerName: 'Id',
        field: 'idLiquidacion',
        filter: true,
        sortable: true,
        // width: 120,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Tipo Vendedor',
        field: 'nombreTipoVendedor',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Vendedor',
        field: 'codigoVendedor',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Nombre Vendedor',
        field: 'nombreVendedor',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Año',
        field: 'anio',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Mes',
        field: 'mesDescripcion',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Total Comisiones',
        field: 'totalComisionVendedor',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.imprimir.bind(this),
          label: this.DAT_BTNS.imprimir,
          colorBoton: this.DAT_BTNCSS.info
        }
      },
      // {
      //   headerName: '',
      //   cellRenderer: 'buttonRenderer',
      //   width: 150,
      //   cellRendererParams: {
      //     onClick: this.eliminar.bind(this),
      //     label: this.DAT_BTNS.eliminar,
      //     colorBoton: this.DAT_BTNCSS.danger
      //   }
      // },
    ];

    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();

  }

  listTiposDeVendedores;
  getTiposDeVendedores() {
    this.loading = true;
    this._tipoDeVendedor.getTiposDeVendedoresPorEstado("1").subscribe((res: any[]) => {
      console.log("getTiposDeVendedores()", res)
      this.loading = false;
      this.listTiposDeVendedores = res;

      if (this.formulario.get("tipoReporte").value == "total") {
        this.listTiposDeVendedores.unshift({
          descripcion: 'TODOS',
          idTipo: '',
        });

        this.formulario.get("vendedorId").setValue('');
        this.formulario.get("tipoVendedor").setValue('');

      }else {
        if (this.listTiposDeVendedores.length > 0) {
          this.formulario.get('tipoVendedor').setValue(this.listTiposDeVendedores[0].idTipo);
        }
      }

      if (this.formulario.get('tipoVendedor').value) {
        setTimeout(() => {
          this.vendedores(this.formulario.get('tipoVendedor').value);
        }, 1000);
      }

    }, (err) => {
      this.loading = false;
      this.listTiposDeVendedores = [];
    });
  }

  getFormValidationErrors() {

    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');

    let totalErrors = 0;

    Object.keys(this.formulario.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.formulario.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });

    console.log('Number of errors: ', totalErrors);
    console.log('formulario: ', this.formulario.getRawValue());
  }

  vendedores(tipoDeVendedor) {
    this.loading = true;
    this._altaDeVendedor.getTodoPorTipo(tipoDeVendedor).subscribe((res: any[]) => {
      console.log("getTiposDeVariables()", res)
      this.loading = false;
      this.listVendedores = res;

      for (let i = 0; i < this.listVendedores.length; i++) {
        this.listVendedores[i].nombreAMostrar = this.listVendedores[i].codigoSap + " - " + this.listVendedores[i].nombreVendedor1;
      }

      if (this.formulario.get("tipoReporte").value == "total") {
        if (this.formulario.get("tipoReporte").value != "individual") {
          this.listVendedores.unshift({
            nombreVendedor1: 'TODOS',
            idVendedor: '',
          });
          this.formulario.get("vendedorId").setValue('');
        }
      } else {
        if (this.listVendedores.length > 0) {
          this.formulario.get("vendedorId").setValue(this.listVendedores[0].idVendedor);
        }
      }

    }, (err) => {
      this.loading = false;
      this.listVendedores = [];
    });

  }

  lsReporteTotal = [];
  lsReporteIndividual = [];
  consultar() {

    this._serviciosCRUD.getTodo(this.formulario.getRawValue()).subscribe((res: any) => {
      console.log("getTodo()", res)
      this.loading = false;
      this.rowData = res;
    }, (err) => {
      this.loading = false;
      this.rowData = [];
    });

  }

  descargarCSV() {
    // if (this.formulario.get("tipoReporte").value == "total") {
      this._serviciosCRUD.getReporteTotal(this.formulario.getRawValue()).subscribe((res: any) => {
        console.log("getReporteTotal()", res)
        this.loading = false;
        this._utils.descargarArchivo(res.nombreArchivo, res.archivoExcel);
      }, (err) => {
        this.loading = false;
      });
    // }
    // else {
    //   this._serviciosCRUD.getReporteIndividual(this.formulario.getRawValue()).subscribe((res: any) => {
    //     console.log("getReporteIndividual()", res)
    //     this.loading = false;
    //     this._utils.descargarArchivo(res.nombreArchivo, res.archivoExcel);
    //   }, (err) => {
    //     this.loading = false;
    //   });
    // }
  }

  descargarPDF() {

  }

  imprimir({ rowData }) {
    console.log("imprimir", rowData)
    console.log("tipoReporte", this.formulario.get("tipoReporte").value)


    // if (this.formulario.get("tipoReporte").value == "total") {
    //   console.log("TOTAL")

    //   let formData = {
    //     anio: rowData.anio,
    //     inicioMes: rowData.mes,
    //     finMes: rowData.mes,
    //     tipoVendedor: rowData.tipoVendedorId,
    //     vendedorId: rowData.idVendedor,
    //   }

    //   this._serviciosCRUD.getReporteTotal(formData).subscribe((res: any) => {
    //     console.log("getReporteTotal()", res)
    //     this.loading = false;
    //     this._utils.descargarArchivo(res.nombreArchivo, res.archivoExcel);
    //   }, (err) => {
    //     this.loading = false;
    //   });
    // }
    // else {
      console.log("INDIVIDUAL")

      let formData = {
        anio: rowData.anio,
        mes: rowData.mes,
        tipoVendedor: rowData.tipoVendedorId,
        vendedorId: rowData.idVendedor,
      }

      this._serviciosCRUD.getReporteIndividual(formData).subscribe((res: any) => {
        console.log("getReporteIndividual()", res)
        this.loading = false;
        this._utils.descargarArchivo(res.nombreArchivo, res.archivoExcel);
      }, (err) => {
        this.loading = false;
      });
    // }
  }

}
